import React from "react";
import { Navigate, useLocation } from "react-router-dom";

export default function ProtectedRoute({ children, allowedRoles = [] }) {
  const location = useLocation();

  // =====================================================
  // AMBIL SESSION LOGIN
  // =====================================================

  const token = localStorage.getItem("token");
  const userData = localStorage.getItem("user");

  // =====================================================
  // TOKEN TIDAK ADA
  // =====================================================

  if (!token) {
    console.warn(
      "ProtectedRoute: token tidak ditemukan untuk:",
      location.pathname
    );

    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // =====================================================
  // DATA USER TIDAK ADA
  // =====================================================

  if (!userData) {
    console.warn(
      "ProtectedRoute: data user tidak ditemukan untuk:",
      location.pathname
    );

    // Hanya hapus token karena session memang tidak lengkap.
    // Jangan menggunakan localStorage.clear().
    localStorage.removeItem("token");

    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // =====================================================
  // PARSE DATA USER
  // =====================================================

  let user;

  try {
    user = JSON.parse(userData);
  } catch (error) {
    console.error("ProtectedRoute: data user tidak valid:", error);

    localStorage.removeItem("token");
    localStorage.removeItem("user");

    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // =====================================================
  // VALIDASI DATA USER
  // =====================================================

  if (!user || typeof user !== "object") {
    console.warn("ProtectedRoute: object user tidak valid.");

    localStorage.removeItem("token");
    localStorage.removeItem("user");

    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // =====================================================
  // AMBIL ROLE
  // =====================================================

  const userRole = user.role ? String(user.role).trim().toLowerCase() : "";

  // =====================================================
  // ROLE TIDAK ADA
  // =====================================================

  if (!userRole) {
    console.warn("ProtectedRoute: role user tidak ditemukan.");

    localStorage.removeItem("token");
    localStorage.removeItem("user");

    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // =====================================================
  // NORMALISASI ROLE YANG DIIZINKAN
  // =====================================================

  const normalizedAllowedRoles = allowedRoles.map((role) =>
    String(role).trim().toLowerCase()
  );

  // =====================================================
  // CEK AKSES ROLE
  // =====================================================

  if (
    normalizedAllowedRoles.length > 0 &&
    !normalizedAllowedRoles.includes(userRole)
  ) {
    console.warn("ProtectedRoute: akses ditolak.", {
      path: location.pathname,
      userRole: userRole,
      allowedRoles: normalizedAllowedRoles,
    });

    // ===================================================
    // ARAHKAN USER KE DASHBOARD SESUAI ROLE
    // ===================================================

    if (userRole === "admin") {
      return <Navigate to="/dashboard-admin" replace />;
    }

    if (userRole === "siswa") {
      return <Navigate to="/dashboard-siswa" replace />;
    }

    if (userRole === "tentor") {
      return <Navigate to="/dashboard-tentor" replace />;
    }

    // Role tidak dikenal
    localStorage.removeItem("token");
    localStorage.removeItem("user");

    return <Navigate to="/login" replace />;
  }

  // =====================================================
  // USER MEMILIKI AKSES
  // =====================================================

  return children;
}
